import {DividendType, dividendTypeName} from "../../types/DividendType";
import {IFilterFunction} from "angular";

export const DividendTypeTranslationPipe = "tfDividendTypeTranslation";

export function dividendTypeTranslationPipe(): IFilterFunction {
    return (type: DividendType | null) => {
        if (type == null) {
            return null;
        } else {
            return "dividends." + type;
        }
    };
}
